import React from "react";
import { View, StyleSheet } from "react-native";
import { Checkbox } from "react-native-paper";
import { DatePickerInput } from "react-native-paper-dates";

import CustomText from "../../../common/general/CustomText/CustomText";
import CustomTextInput from "../../../common/general/CustomTextInput/CustomTextInput";
import { useGradingCenterSubmissions } from "../../../../contexts/GradingCenterContext";

const GradingSection: React.FC = () => {
  const { updatedAssignmentPayload, setUpdatedAssignmentPayload } = useGradingCenterSubmissions();

  return (
    <View style={styles.gradingSection}>
      <View style={styles.gradingInputs}>
        <View style={styles.gradeInputContainer}>
          <CustomText text="Grade" size="s" weight="bold" style={styles.label} />
          <View style={styles.gradeInputWrapper}>
            <CustomTextInput
              keyboardType="numeric"
              value={updatedAssignmentPayload?.grade == null ? "" : updatedAssignmentPayload.grade.toString()}
              onChangeText={(value) =>
                setUpdatedAssignmentPayload({
                  ...updatedAssignmentPayload,
                  grade: value === "" ? null : Number(value),
                })
              }
              placeholder="Enter grade"
              min="0"
              max="100"
              style={styles.gradeInput}
            />
            <CustomText text="%" size="s" style={styles.gradeSuffix} useTranslationText={false} />
          </View>
          <CustomText text="Enter a grade from 0 to 100" size="xs" style={styles.gradeHelp} />
        </View>

        <View style={styles.retakeOptionContainer}>
          <View style={styles.checkboxContainer}>
            <Checkbox
              status={updatedAssignmentPayload?.retakeAllowed ? "checked" : "unchecked"}
              onPress={() =>
                setUpdatedAssignmentPayload({
                  ...updatedAssignmentPayload,
                  retakeAllowed: !updatedAssignmentPayload?.retakeAllowed,
                  retakeDeadline: new Date(),
                })
              }
              theme={{ colors: { primary: "#3B82F6" } }}
            />
            <CustomText text="Allow Retake" size="s" style={styles.checkboxLabel} />
          </View>
          {updatedAssignmentPayload?.retakeAllowed && (
            <View style={styles.retakeOptions}>
              <CustomText text="Retake Deadline" size="s" weight="bold" style={styles.label} />
              <DatePickerInput
                locale="en"
                label={undefined}
                value={updatedAssignmentPayload?.retakeDeadline}
                onChange={(date) => setUpdatedAssignmentPayload({ ...updatedAssignmentPayload, retakeDeadline: date })}
                inputMode="start"
                mode="outlined"
                withDateFormatInLabel={false}
                outlineColor={"#D1D5DB"}
                activeOutlineColor={"#3B82F6"}
                placeholder="MM/DD/YYYY"
                theme={{
                  roundness: 8,
                }}
                style={styles.dateInput}
                aria-label="Retake deadline date picker"
              />
            </View>
          )}
        </View>
      </View>

      <View style={styles.feedbackContainer}>
        <CustomText text="Feedback for Student (Optional)" size="s" weight="bold" style={styles.label} />
        <CustomTextInput
          value={updatedAssignmentPayload?.feedback}
          onChangeText={(value) => setUpdatedAssignmentPayload({ ...updatedAssignmentPayload, feedback: value })}
          placeholder="Provide feedback on the student's work..."
          multiline
          numberOfLines={4}
          maxLength={500}
          style={styles.feedbackTextarea}
        />
        <CustomText
          text="character_count"
          size="xs"
          style={styles.feedbackCharCount}
          interpolation={{ value: updatedAssignmentPayload?.feedback?.length || 0 }}
        />
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  gradingSection: {
    backgroundColor: "#F9FAFB",
    borderWidth: 1,
    borderColor: "#E5E7EB",
    borderRadius: 12,
    padding: 24,
    marginBottom: 32,
  },
  gradingInputs: {
    flexDirection: "row",
    gap: 24,
    marginBottom: 24,
  },
  gradeInputContainer: {
    flex: 1,
  },
  gradeInputWrapper: {
    flexDirection: "row",
    alignItems: "center",
    position: "relative",
  },
  gradeInput: {
    flex: 1,
    borderWidth: 1,
    borderColor: "#D1D5DB",
    borderRadius: 8,
    paddingHorizontal: 16,
    paddingVertical: 12,
    paddingRight: 40,
    fontSize: 16,
  },
  gradeSuffix: {
    position: "absolute",
    right: 16,
    color: "#6B7280",
    fontWeight: "600",
  },
  gradeHelp: {
    color: "#6B7280",
    marginTop: 6,
  },
  retakeOptionContainer: {
    flex: 1,
  },
  checkboxContainer: {
    flexDirection: "row",
    alignItems: "center",
  },
  checkboxLabel: {
    color: "#374151",
  },
  retakeOptions: {
    marginTop: 12,
    paddingLeft: 28,
  },
  dateInput: {
    backgroundColor: "#FFFFFF",
    maxHeight: 56,
  },
  feedbackContainer: {
    flex: 1,
  },
  feedbackTextarea: {
    marginTop: 8,
    minHeight: 100,
    textAlignVertical: "top",
  },
  feedbackCharCount: {
    color: "#6B7280",
    textAlign: "right",
    marginTop: 6,
  },
  label: {
    color: "#344054",
    fontWeight: "500",
  },
});

export default GradingSection;
